import { render, staticRenderFns } from "./LicEdit.vue?vue&type=template&id=58410031"
import script from "./LicEdit.vue?vue&type=script&lang=js"
export * from "./LicEdit.vue?vue&type=script&lang=js"
import style0 from "./LicEdit.vue?vue&type=style&index=0&id=58410031&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports